import type {DimensionItemDTO, ICalendarItemDTO, IMeasureItemDTO, IFieldItemDTO} from './dimensionItems.types';

export function isCalendarItemDTO<T>(item: DimensionItemDTO<T>): item is ICalendarItemDTO<T> {
  return "frequencyId" in item;
}

export function isMeasureItemDTO<T>(item: DimensionItemDTO<T>): item is IMeasureItemDTO<T> {
  return "isMeasure" in item;
}

export function isFieldItemDTO<T>(item: DimensionItemDTO<T>): item is IFieldItemDTO<T> {
  return "isField" in item;
}